/**
 * Merges Tailwind CSS classes with proper conflict resolution.
 * Uses clsx for conditional class names and tailwind-merge for deduplication.
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

